export default "__VITE_ASSET__Bm9SCIN8__"